import styled, { css } from 'styled-components';
import colors from '../../style/colors';
import { actionLight } from '../../style/theme-helpers';
import BaseCard, { BaseCardProps } from './base-card';

const boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
const variants = {
  'border-left-light-coral': css`
    border-left: 8px solid ${colors.lightCoral};
    box-shadow: ${boxShadow};
  `,
  'border-left-action-light': css`
    border-left: 8px solid ${actionLight};
    box-shadow: ${boxShadow};
  `,
  'border-left-light-violet': css`
    border-left: 8px solid ${colors.lightLavender};
    box-shadow: ${boxShadow};
  `,
};

const hoverBoxShadow = '1px 4px 10px 0px rgba(0, 0, 0, 0.08)';
const hoverVariants = {
  'border-left-light-coral': css`
    border-left: 8px solid ${colors.coral};
    box-shadow: ${hoverBoxShadow};
  `,
  'border-left-action-light': css`
    border-left: 8px solid ${colors.sky};
    box-shadow: ${hoverBoxShadow};
  `,
  'border-left-light-violet': css`
    border-left: 8px solid ${colors.lavender};
    box-shadow: ${hoverBoxShadow};
  `,
};

const activeVariants = {
  'border-left-light-coral': css`
    border: 1px solid ${colors.coral};
    border-left: 8px solid ${colors.coral};
  `,
  'border-left-action-light': css`
    border: 1px solid ${colors.sky};
    border-left: 8px solid ${colors.sky};
  `,
  'border-left-light-violet': css`
    border: 1px solid ${colors.lavender};
    border-left: 8px solid ${colors.lavender};
  `,
};

export type BorderAccentCardVariant = keyof typeof variants;

export interface BorderAccentCardProps extends BaseCardProps {
  variant?: BorderAccentCardVariant;
}

const BorderAccentCard = styled(BaseCard).withConfig({
  shouldForwardProp: prop => !['variant'].includes(prop),
})<BorderAccentCardProps>`
  transition:
    border-color 300ms ease,
    box-shadow 300ms ease;
  background: ${colors.white};
  border: 1px solid transparent;

  ${({ variant }) => variant && variants[variant]};

  &.disabled,
  &[disabled] {
    user-select: none;
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.6;
  }

  ${({ clickable, onClick }) =>
    (clickable === false || !onClick) &&
    css`
      pointer-events: none;
    `}

  ${({ clickable, variant }) =>
    clickable !== false && variant
      ? css`
          &:hover:not(.disabled):not([disabled]) {
            ${hoverVariants[variant]};
            cursor: pointer;
          }

          &:focus-visible,
          &.active {
            ${activeVariants[variant]};
          }
        `
      : undefined}
`;

export default BorderAccentCard;
